import { getWorkspacePermissionApi, getWorkspaceFieldValueApi, getWorkspaceInfoApi } from '../../../../components/apis/workspace_api/view';
import { getFieldLimitApi, createCustomFieldValue, getCustomFieldValue, saveCustomFieldValue } from 'library-@/apis/workspace_api/custom_field';
import _ from 'lodash';

export default class FieldService {
    constructor(patentId) {
        this.patentId = patentId;
    }

    static createField(param) {
        //  区分新增和编辑
        return createCustomFieldValue(param);
    }

    static getFieldLimit(folder_id) {
        return getFieldLimitApi(folder_id);
    }

    getFieldList(param) {
        const { isShared } = param;
        if (isShared) {
            return Promise.all([
                getWorkspacePermissionApi({
                    spaceId: param.spaceId,
                    folderId: param.folderId,
                }),
                getWorkspaceFieldValueApi({
                    patent_id: this.patentId,
                    folder_id: param.folderId,
                    view_type: param.wsViewType,
                }),
                getWorkspaceInfoApi({
                    folder_id: param.folderId
                })
            ]).then(res => {
                return {
                    permission: _.get(res, 0, {}),
                    fieldObj: _.get(res, 1, {}),
                    info: _.get(res, 2, {}),
                };
            });
        }
        return getCustomFieldValue(this.patentId)
            .then(res => {
                return {
                    fieldObj: _.get(res, 'data.data', {}),
                };
            });
    }

    saveFieldValue(param) {
        return saveCustomFieldValue({
            patent_id: this.patentId,
            ...param
        });
    }
}
